/**
 * Returns `src` with its `scale` query param set to `scale` (or removed when
 * `scale` is falsy), leaving the rest of the URL byte-identical.
 *
 * Deliberately string-based rather than `new URL()` + `searchParams.set()`:
 * a Firebase download URL carries a signed `token=` param, and round-tripping
 * it through `URL` re-encodes the query. Legacy srcs also append the param as
 * `&scale=` onto a URL that already has a query, so both separators are
 * handled.
 */
export const withImageScale = (src: string, scale: number): string => {
  const withoutScale = src
    // `scale` followed by other params — keep the leading separator
    .replace(/([?&])scale=[^&]*&/, "$1")
    // `scale` as the last (or only) param
    .replace(/[?&]scale=[^&]*$/, "");

  if (!scale) {
    return withoutScale;
  }
  const separator = withoutScale.includes("?") ? "&" : "?";
  return `${withoutScale}${separator}scale=${scale}`;
};
